import { useEffect } from 'react';

import { Layout, Page } from '@nimbus-ds/patterns';
import { navigateHeaderRemove } from '@tiendanube/nexo';

import nexo from '../../nexoClient';
import { useTranslation } from 'react-i18next';
import { Box, Tabs } from '@nimbus-ds/components';
import BriefingsAwaitListPage from './BriefingsAwaitListPage';
import ItemsAwaitChangeArtListPage from './ItemsAwaitChangeArtListPage';

function PageMain() {
  const { t } = useTranslation();

  useEffect(() => {
    navigateHeaderRemove(nexo);
  }, []);

  return (
    <>
      <Page>
        <Page.Header title={t('MainPage.title')} />
        <Page.Body>
          <Layout columns="1">
            <Layout.Section>
              <Box display="grid" gap="10">
                <Tabs fullWidth>
                  <Tabs.Item label="Briefings para aprovação">
                    <BriefingsAwaitListPage />
                  </Tabs.Item>
                  <Tabs.Item label="Solicitações de alteração de arte">
                    <ItemsAwaitChangeArtListPage />
                  </Tabs.Item>
                </Tabs>
              </Box>
            </Layout.Section>
          </Layout>
        </Page.Body>
      </Page>
    </>
  );
}

export default PageMain;
